import React from 'react';
import VerticalSeperator from '../../Utils/VerticalSeperator';
import i18n from '../../../../utils/ChrI18n';
import { keyBoardAccessibilityAttributes } from '../../../../utils/GeneralUtils';

export default function SelectAllAndClear(props) {
  return (
    <React.Fragment>
      <a
        className="cjs-select-all-clear--select"
        onClick={ props.selectAllClickHandler }
        { ...keyBoardAccessibilityAttributes }
      >
        { i18n.t("display_string.Select_All") }
      </a>
      <VerticalSeperator />
      <a
        className="cjs-select-all-clear--clear"
        onClick={ props.clearClickHandler }
        { ...keyBoardAccessibilityAttributes }
      >
        { i18n.t("display_string.Clear") }
      </a>
    </React.Fragment>
  );
}